import React, { createContext } from 'react';
import { Application, ApplicationAction, Catalogue, ISalesforceService } from 'src/features/common';

export type ApplicationContextType = {
  application: Application;
  dispatch: React.Dispatch<ApplicationAction>;
  salesforceService: ISalesforceService;
  children: React.ReactFragment;
  catalogue: Catalogue;
};

export const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);

export function ApplicationProvider(props: ApplicationContextType) {
  return (
    <ApplicationContext.Provider value={{ ...props }}>{props.children}</ApplicationContext.Provider>
  );
}
